import * as Icons from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/lib/motion";
import { BENEFITS, IMAGES } from "@/data/content";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const Benefits = () => (
  <div data-testid="benefits-page">
    <PageHero eyebrow="Risi Wellness information" title={<>Massage & wellness<br />at a glance</>}
      subtitle="Explore the appointment formats, treatment options and service details available from Risi Wellness." />

    <section className="max-w-7xl mx-auto px-5 sm:px-8 pb-24">
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {BENEFITS.map((b, i) => {
          const Icon = Icons[b.icon] || Icons.Leaf;
          return (
            <Reveal key={b.title} delay={(i % 4) * 0.06}>
              <div className="h-full rounded-2xl border border-border bg-card p-7 hover:-translate-y-1 hover:shadow-lg transition-all duration-300">
                <div className="w-14 h-14 rounded-full bg-primary/10 text-primary flex items-center justify-center mb-5"><Icon size={26} /></div>
                <h3 className="font-serif text-2xl text-primary mb-2">{b.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{b.text}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>

    <section className="relative overflow-hidden">
      <img src={IMAGES.sunTree} alt="" aria-hidden="true" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-primary/75" />
      <div className="relative z-10 max-w-4xl mx-auto px-5 sm:px-8 py-24 sm:py-32 text-center">
        <Reveal>
          <h2 className="font-serif text-4xl sm:text-6xl text-primary-foreground leading-tight mb-6">Choose your appointment</h2>
          <p className="text-primary-foreground/85 text-lg max-w-2xl mx-auto mb-8">Review the service details and use the booking page to view current appointment availability.</p>
          <Link to="/booking" className="inline-flex items-center gap-2 rounded-full bg-secondary text-secondary-foreground px-8 py-4 font-semibold hover:bg-secondary/90 transition-colors">Book Now <ArrowUpRight size={18} /></Link>
        </Reveal>
      </div>
    </section>
  </div>
);

export default Benefits;
